
export class IMessageCode {}

